import posthog from "posthog-js";
import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";
import { AnalyticsEvents } from "./analytics/events";

function sendToPostHog({ name, value, rating, id }: Metric) {
  posthog.capture(AnalyticsEvents.WEB_VITALS, {
    metric: name,
    // CLS is unitless (0–1 range); multiply by 1000 to store as integer ms-equivalent
    value: Math.round(name === "CLS" ? value * 1000 : value),
    rating,
    id,
  });
}

export function reportWebVitals() {
  onCLS(sendToPostHog);
  onFCP(sendToPostHog);
  onINP(sendToPostHog);
  onLCP(sendToPostHog);
  onTTFB(sendToPostHog);
}
